(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('announcement-rotator')) {
    customElements.define(
      'announcement-rotator',
      class AnnouncementRotator extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.announcement__item'));
          if (this.items.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const every = (parseInt(this.dataset.interval, 10) || 5) * 1000;
          this.i = 0;
          this.timer = setInterval(() => {
            this.items[this.i].hidden = true;
            this.i = (this.i + 1) % this.items.length;
            this.items[this.i].hidden = false;
          }, every);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  // Submitting on change keeps the selector usable without a separate Go button.
  document.querySelectorAll('[data-locale-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form && sel.form.submit(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cd-close]')) { e.preventDefault(); this.close(); return; }
        const b = e.target.closest('[data-change]');
        if (b) { this.change(b.closest('.cditem').dataset.key, parseInt(b.dataset.change, 10)); return; }
        if (e.target.closest('[data-cd-apply]')) { this.applyDiscount(); return; }
      });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-input]')) this.change(e.target.closest('.cditem').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
        if (e.target.matches('[data-cd-note]')) this.updateNote(e.target.value);
      });
      // open when an item is added to cart
      document.addEventListener('cart:updated', (e) => { this.refresh(); if (e.detail && e.detail.source === 'product') this.open(); });
      // intercept cart links across the site -> open drawer instead of navigating.
      // Escape hatch: a link with [data-no-drawer] (or a normal modified click) still reaches
      // the full /cart page, so the cart template stays accessible.
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href$="/cart"]');
        if (a && !a.hasAttribute('data-no-drawer') && !e.metaKey && !e.ctrlKey) { e.preventDefault(); this.refresh(); this.open(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
    }
    open() { if (this.classList.contains('is-open')) return; this.classList.add('is-open'); window.MetryScrollLock.lock(); }
    close() { if (!this.classList.contains('is-open')) return; this.classList.remove('is-open'); window.MetryScrollLock.unlock(); }
    async change(id, quantity) {
      this.classList.add('is-loading');
      try {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity }) });
        await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer' } }));
      } catch (e) {} finally { this.classList.remove('is-loading'); }
    }
    async updateNote(note) { try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) }); } catch (e) {} }
    applyDiscount() {
      const input = this.querySelector('[data-cd-code]'); const code = input && input.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
    }
    async refresh() {
      try {
        const html = await (await fetch('/?section_id=' + this.section)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (fresh) this.innerHTML = fresh.innerHTML;
      } catch (e) {}
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-tabs"] && !Shopify.designMode) return;
  try {
    
  class AtomCaseTabs extends HTMLElement {
    connectedCallback() {
      this.groups = [...this.querySelectorAll('.case-tabs__group')];
      this.matRows = [...this.querySelectorAll('.case-tabs__mats')];
      this.mats = [...this.querySelectorAll('.case-tabs__mat')];
      this.panels = [...this.querySelectorAll('.case-tabs__panel')];
      if (!this.mats.length) return;

      this.groups.forEach((b) => {
        b.addEventListener('click', () => this.selectGroup(b.dataset.group));
      });
      this.mats.forEach((b) => {
        b.addEventListener('click', () => this.selectMat(b.dataset.mat));
      });

      this.addEventListener('keydown', this.onKey.bind(this));

      const first = this.groups.length ? this.groups[0].dataset.group : 'g1';
      this.selectGroup(first);
    }

    selectGroup(group) {
      this.groups.forEach((b) => {
        const on = b.dataset.group === group;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      this.matRows.forEach((row) => {
        row.hidden = row.dataset.groupPanel !== group;
      });
      // Fall back to this group's first material so no panel is left orphaned.
      const firstMat = this.mats.find((m) => m.dataset.mat.indexOf(group + '-') === 0);
      if (firstMat) this.selectMat(firstMat.dataset.mat);
    }

    selectMat(key) {
      this.mats.forEach((b) => {
        const on = b.dataset.mat === key;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p) => {
        p.hidden = p.dataset.panel !== key;
      });
    }

    onKey(e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const row = e.target.closest('[role="tablist"]');
      if (!row) return;
      const items = [...row.querySelectorAll('[role="tab"]')].filter((b) => !b.closest('[hidden]'));
      const i = items.indexOf(e.target);
      if (i < 0) return;
      e.preventDefault();
      const next = items[(i + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length];
      next.focus();
      next.click();
    }
  }

  if (!customElements.get('atom-case-tabs')) {
    customElements.define('atom-case-tabs', AtomCaseTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
  // Guarded: the same element is also registered by product-tabs; whichever section
  // loads first wins and the other is a no-op.
  if (!customElements.get('atom-tabs')) {
    customElements.define(
      'atom-tabs',
      class AtomTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          if (!this.tabs.length) return;
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
        }

        select(i) {
          this.tabs.forEach((tab, n) => {
            const active = n === i;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            if (this.panels[n]) this.panels[n].hidden = !active;
          });
          this.tabs[i].focus();
        }

        onKey(e, i) {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atom-deal')) {
    customElements.define(
      'atom-deal',
      class AtomDeal extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.select = this.querySelector('[data-deal-select]');
          this.priceEl = this.querySelector('[data-deal-price]');
          this.ctaText = this.querySelector('[data-deal-cta-text]');
          if (!this.form) return;

          if (this.select && this.priceEl) {
            this.select.addEventListener('change', () => this.syncPrice());
          }
          this.form.addEventListener('submit', (e) => this.submit(e));
        }

        syncPrice() {
          const opt = this.select.selectedOptions[0];
          if (opt && opt.dataset.price) this.priceEl.textContent = opt.dataset.price;
        }

        async submit(e) {
          e.preventDefault();
          const btn = this.form.querySelector('[name="add"]');
          if (!btn || btn.disabled) return;

          const original = this.ctaText ? this.ctaText.textContent : '';
          btn.disabled = true;

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: Number(new FormData(this.form).get('id')),
                quantity: 1
              })
            });
            if (!res.ok) throw new Error(await res.text());

            if (this.ctaText) this.ctaText.textContent = this.dataset.addedLabel || 'Added';
            // source:'product' tells the cart drawer to pop open, not just refresh.
            document.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'product' } })
            );
          } catch (err) {
            // Fall back to a full page POST so the shopper is never stuck.
            this.form.submit();
            return;
          } finally {
            setTimeout(() => {
              btn.disabled = false;
              if (this.ctaText) this.ctaText.textContent = original;
            }, 1800);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["entry-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atom-popup')) {
    customElements.define(
      'atom-popup',
      class AtomPopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-popup-dialog]');
          if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

          this.key = this.dataset.key;
          this.preview = this.dataset.preview === 'true';

          const closeBtn = this.querySelector('[data-popup-close]');
          if (closeBtn) closeBtn.addEventListener('click', () => this.dismiss());
          // Native <dialog> fires close for Esc too, so record the dismissal there.
          this.dialog.addEventListener('close', () => this.remember());
          this.dialog.addEventListener('click', (e) => {
            // Clicking the backdrop resolves to the dialog element itself.
            if (e.target === this.dialog) this.dismiss();
          });

          // A successful signup re-renders with the success message — show it immediately.
          if (this.querySelector('.entry-popup__success')) {
            this.show();
            return;
          }

          if (this.preview) { this.show(); return; }
          if (this.suppressed()) return;

          this.arm();
        }

        suppressed() {
          try {
            const until = window.localStorage.getItem(this.key);
            return until && Number(until) > Date.now();
          } catch (e) {
            return false;
          }
        }

        arm() {
          const delay = Number(this.dataset.delay) || 0;
          const scrollPct = Number(this.dataset.scroll) || 0;

          this.timer = setTimeout(() => this.show(), delay);

          if (scrollPct > 0) {
            this.onScroll = () => {
              const doc = document.documentElement;
              const max = doc.scrollHeight - window.innerHeight;
              if (max > 0 && (window.scrollY / max) * 100 >= scrollPct) this.show();
            };
            // Passive: never blocks scrolling.
            window.addEventListener('scroll', this.onScroll, { passive: true });
          }
        }

        show() {
          if (this.shown) return;
          this.shown = true;
          clearTimeout(this.timer);
          if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
          this.dialog.showModal();
        }

        dismiss() {
          if (this.dialog.open) this.dialog.close();
        }

        remember() {
          const days = Number(this.dataset.frequency) || 0;
          if (days <= 0) return;
          try {
            window.localStorage.setItem(this.key, String(Date.now() + days * 864e5));
          } catch (e) {
            /* private mode — popup simply shows again next visit */
          }
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-center"] && !Shopify.designMode) return;
  try {
    
  class AtomFaqCenter extends HTMLElement {
    connectedCallback() {
      this.chips = [...this.querySelectorAll('.faqc__chip')];
      this.cats = [...this.querySelectorAll('.faqc__cat')];
      this.items = [...this.querySelectorAll('.faqc__item')];
      this.navRoot = this.querySelector('[data-nav]');
      this.navItems = this.buildNav();
      this.empty = this.querySelector('.faqc__empty');
      this.listTitle = this.querySelector('[data-list-title]');
      if (!this.items.length) return;

      this.machine = this.chips.length ? this.chips[0].dataset.machine : null;
      this.category = this.cats.length ? this.cats[0].dataset.category : null;

      // `/pages/faqs#A70 Max` — the hash arrives percent-encoded.
      const hash = decodeURIComponent((location.hash || '').slice(1)).trim();
      if (hash) {
        const hit = this.chips.find(
          (c) => c.dataset.machine.toLowerCase() === hash.toLowerCase()
        );
        if (hit) this.machine = hit.dataset.machine;
      }

      this.chips.forEach((c) =>
        c.addEventListener('click', () => {
          this.machine = c.dataset.machine;
          this.apply();
        })
      );
      this.cats.forEach((c) =>
        c.addEventListener('click', () => {
          this.category = c.dataset.category;
          this.apply();
        })
      );
      this.querySelectorAll('.faqc__nav-btn').forEach((b) =>
        b.addEventListener('click', () => this.jump(b))
      );

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const row = e.target.closest('[role="tablist"]');
        if (!row) return;
        const list = [...row.querySelectorAll('[role="tab"]')];
        const i = list.indexOf(e.target);
        if (i < 0) return;
        e.preventDefault();
        const next = list[(i + (e.key === 'ArrowRight' ? 1 : -1) + list.length) % list.length];
        next.focus();
        next.click();
      });

      this.apply();
      this.initVideo();
    }

    // 侧栏目录由条目派生：问答语料放在 snippet 里（402 条远超 section 的 50 block 上限），
    // 服务端没法同时再渲染一份导航，也没必要 —— 两边永远一致更省事。
    buildNav() {
      if (!this.navRoot) return [];
      const frag = document.createDocumentFragment();
      const out = [];
      this.items.forEach((item, i) => {
        if (!item.id) item.id = 'faq-item-' + i;
        const li = document.createElement('li');
        li.className = 'faqc__nav-item';
        li.dataset.machine = item.dataset.machine || 'All';
        li.dataset.category = item.dataset.category || '';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'faqc__nav-btn';
        btn.dataset.target = item.id;
        btn.textContent = item.querySelector('.faqc__q-text').textContent;
        li.appendChild(btn);
        frag.appendChild(li);
        out.push(li);
      });
      this.navRoot.appendChild(frag);
      return out;
    }

    matches(el) {
      const mOk = !this.machine || el.dataset.machine === this.machine || el.dataset.machine === 'All';
      const cOk = !this.category || el.dataset.category === this.category;
      return mOk && cOk;
    }

    apply() {
      this.chips.forEach((c) => {
        const on = c.dataset.machine === this.machine;
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      this.cats.forEach((c) => {
        const on = c.dataset.category === this.category;
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        if (on && this.listTitle) this.listTitle.textContent = c.querySelector('.faqc__cat-title').textContent;
      });

      let shown = 0;
      this.items.forEach((el) => {
        const ok = this.matches(el);
        el.hidden = !ok;
        if (!ok) el.open = false;
        if (ok) shown++;
      });
      this.navItems.forEach((el) => {
        el.hidden = !this.matches(el);
      });
      if (this.empty) this.empty.hidden = shown > 0;
    }

    // 视频弹窗。按铁律不引第三方播放器脚本：用原生 <dialog>，
    // 且只在用户点击后才插入 iframe —— 点击之前页面上没有任何 YouTube 资源。
    // 关闭时移除 iframe，播放随之停止（否则音频会在后台继续）。
    initVideo() {
      this.dialog = this.querySelector('[data-video-dialog]');
      this.dialogBody = this.querySelector('[data-video-body]');
      if (!this.dialog) return;

      this.querySelectorAll('[data-videos]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          // 按钮在 <summary> 里，不拦住的话会顺带展开/收起折叠
          e.preventDefault();
          e.stopPropagation();
          let urls = [];
          try { urls = JSON.parse(btn.dataset.videos); } catch (err) { urls = []; }
          this.openVideos(urls);
        });
      });

      // 图片点击放大：原站的示意图是可点的（cursor: pointer），复用同一个弹窗
      this.addEventListener('click', (e) => {
        const img = e.target.closest('.faqc__fig img');
        if (!img) return;
        this.dialogBody.textContent = '';
        const big = document.createElement('img');
        big.src = img.currentSrc || img.src;
        big.alt = img.alt || '';
        this.dialogBody.appendChild(big);
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      });

      const close = () => this.closeVideos();
      this.querySelector('[data-video-close]').addEventListener('click', close);
      this.dialog.addEventListener('close', () => { this.dialogBody.textContent = ''; });
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();   // 点遮罩关闭
      });
    }

    embedUrl(u) {
      const m = String(u).match(/(?:youtu\.be\/|v=|embed\/)([\w-]{6,})/);
      return m ? `https://www.youtube-nocookie.com/embed/${m[1]}` : null;
    }

    openVideos(urls) {
      this.dialogBody.textContent = '';
      urls.map((u) => this.embedUrl(u)).filter(Boolean).forEach((src) => {
        const f = document.createElement('iframe');
        f.src = src;
        f.title = 'Video';
        f.allow = 'accelerometer; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        f.loading = 'lazy';
        this.dialogBody.appendChild(f);
      });
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    }

    closeVideos() {
      if (this.dialog.open) this.dialog.close();
    }

    jump(btn) {
      const target = this.querySelector('#' + CSS.escape(btn.dataset.target));
      if (!target || target.hidden) return;
      this.items.forEach((i) => {
        i.open = i === target;
      });
      this.querySelectorAll('.faqc__nav-btn').forEach((b) =>
        b.setAttribute('aria-current', b === btn ? 'true' : 'false')
      );
      target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  if (!customElements.get('atom-faq-center')) {
    customElements.define('atom-faq-center', AtomFaqCenter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('country-select')) {
    customElements.define('country-select', class extends HTMLElement {
      connectedCallback() {
        const s = this.querySelector('select');
        if (s) s.addEventListener('change', () => s.form && s.form.submit());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('atom-mega')) {
    customElements.define(
      'atom-mega',
      class AtomMega extends HTMLElement {
        connectedCallback() {
          this.triggers = Array.from(this.querySelectorAll('[data-mega-trigger]'));
          this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
          this.openKey = null;
          this.hoverTimer = null;

          this.triggers.forEach((t) => {
            const key = t.dataset.megaTrigger;
            // Pointer opens on hover with a short intent delay so sweeping across the
            // bar does not flash every panel.
            t.addEventListener('pointerenter', () => this.scheduleOpen(key));
            t.addEventListener('focus', () => {
              if (this.suppressFocusOpen) return;
              this.open(key);
            });
            t.addEventListener('click', (e) => {
              // Only swallow the click when the panel is still closed (touch devices
              // need one tap to reveal it). Once open, the link navigates like the
              // reference site does instead of just collapsing the panel.
              if (this.openKey !== key) {
                e.preventDefault();
                this.open(key);
              }
            });
          });

          this.addEventListener('pointerleave', () => this.scheduleClose());
          this.addEventListener('pointerenter', () => clearTimeout(this.hoverTimer));

          // Tabbing out of the panel used to leave it open, covering the page.
          this.addEventListener('focusout', (e) => {
            if (!this.contains(e.relatedTarget)) this.closeAll();
          });

          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.openKey) {
              const key = this.lastKey;
              this.closeAll();
              // Returning focus to the trigger would hit the focus handler below and
              // immediately reopen the panel, so Esc appeared to do nothing the first
              // time. Suppress that one re-entry.
              this.suppressFocusOpen = true;
              const t = this.triggers.find((x) => x.dataset.megaTrigger === key);
              if (t) t.focus();
              setTimeout(() => { this.suppressFocusOpen = false; }, 0);
            }
          });

          // Left-rail entries swap the product grid without navigating.
          this.querySelectorAll('[data-mega-entry]').forEach((entry) => {
            entry.addEventListener('pointerenter', () => this.showContent(entry));
            entry.addEventListener('focus', () => this.showContent(entry));
          });

          // In the double layout, level-two items swap the level-three column and
          // select that group's first product panel.
          this.querySelectorAll('[data-mega-group]').forEach((group) => {
            group.addEventListener('pointerenter', () => this.showGroup(group));
            group.addEventListener('focus', () => this.showGroup(group));
          });
        }

        scheduleOpen(key) {
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => this.open(key), 90);
        }

        scheduleClose() {
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => this.closeAll(), 160);
        }

        open(key) {
          this.lastKey = key;
          this.openKey = key;
          this.panels.forEach((p) => { p.hidden = p.dataset.megaPanel !== key; });
          this.triggers.forEach((t) => {
            t.setAttribute('aria-expanded', t.dataset.megaTrigger === key ? 'true' : 'false');
          });
        }

        closeAll() {
          this.openKey = null;
          this.panels.forEach((p) => { p.hidden = true; });
          this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        }

        showContent(entry) {
          const key = entry.dataset.megaEntry;
          const panel = entry.closest('[data-mega-panel]');
          if (!panel || !key) return;
          panel.querySelectorAll('[data-mega-entry]').forEach((e) => e.removeAttribute('aria-current'));
          entry.setAttribute('aria-current', 'true');
          panel.querySelectorAll('[data-mega-content]').forEach((c) => {
            c.hidden = c.dataset.megaContent !== key;
          });
        }

        showGroup(group) {
          const key = group.dataset.megaGroup;
          const panel = group.closest('[data-mega-panel]');
          if (!panel || !key) return;

          panel.querySelectorAll('[data-mega-group]').forEach((item) => item.removeAttribute('aria-current'));
          group.setAttribute('aria-current', 'true');

          let activeSubmenu = null;
          panel.querySelectorAll('[data-mega-submenu]').forEach((submenu) => {
            submenu.hidden = submenu.dataset.megaSubmenu !== key;
            if (!submenu.hidden) activeSubmenu = submenu;
          });

          const firstEntry = activeSubmenu && activeSubmenu.querySelector('[data-mega-entry]');
          this.showContent(firstEntry || group);
        }
      }
    );
  }

  // Nothing else updates the header count — the drawer only re-renders itself, so the
  // badge sat at 0 after an AJAX add until a full page reload.
  document.addEventListener('cart:updated', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('visually-hidden', cart.item_count === 0);
        });
      })
      .catch(function () { /* badge just stays as-is */ });
  });

  (function () {
    var burger = document.querySelector('[data-burger]');
    var drawer = document.querySelector('[data-drawer]');
    var backdrop = document.querySelector('[data-drawer-backdrop]');
    if (!burger || !drawer) return;

    function setOpen(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        drawer.hidden = false;
        if (backdrop) backdrop.hidden = false;
        // Next frame so the transition has a start value to animate from.
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          if (backdrop) backdrop.classList.add('is-open');
        });
        if (window.MetryScrollLock) window.MetryScrollLock.lock();
      } else {
        drawer.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        if (window.MetryScrollLock) window.MetryScrollLock.unlock();
        window.setTimeout(function () {
          if (!drawer.classList.contains('is-open')) {
            drawer.hidden = true;
            if (backdrop) backdrop.hidden = true;
          }
        }, 300);
      }
    }

    burger.addEventListener('click', function () {
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(false); });
    });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') setOpen(false);
    });
  })();

  if (!customElements.get('atom-search')) {
    customElements.define('atom-search', class extends HTMLElement {
      connectedCallback() {
        this.trigger = document.querySelector('[data-search-open]');
        this.input = this.querySelector('[data-search-input]');
        if (this.trigger) this.trigger.addEventListener('click', () => this.open());
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-search-close]')) this.close();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !this.hidden) this.close();
        });
      }
      open() {
        this.hidden = false;
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
        if (window.MetryScrollLock) window.MetryScrollLock.lock();
        if (this.input) this.input.focus();
      }
      close() {
        this.hidden = true;
        if (this.trigger) {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus();
        }
        if (window.MetryScrollLock) window.MetryScrollLock.unlock();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atom-hero')) {
    customElements.define(
      'atom-hero',
      class AtomHero extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-hero-track]');
          if (!this.track) return;
          this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
          if (this.slides.length < 2) return;

          this.labels = Array.from(this.querySelectorAll('[data-hero-go]'));
          this.prevBtn = this.querySelector('[data-hero-prev]');
          this.nextBtn = this.querySelector('[data-hero-next]');

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
          this.labels.forEach((b) =>
            b.addEventListener('click', () => this.go(Number(b.dataset.heroGo)))
          );

          // Position is the source of truth, same as the shared carousel — no separate
          // index to drift out of sync with what is actually on screen.
          this.track.addEventListener('scroll', () => this.queueSync(), { passive: true });

          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
          });

          this.startAuto();
          // Pause while the shopper is looking at or interacting with it.
          this.addEventListener('pointerenter', () => this.stopAuto());
          this.addEventListener('pointerleave', () => this.startAuto());
          this.addEventListener('focusin', () => this.stopAuto());
          this.addEventListener('focusout', (e) => {
            if (!this.contains(e.relatedTarget)) this.startAuto();
          });
          document.addEventListener('visibilitychange', () => {
            document.hidden ? this.stopAuto() : this.startAuto();
          });

          this.sync();
        }

        get index() {
          const w = this.track.clientWidth || 1;
          return Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w));
        }

        behavior() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        }

        go(i) {
          const n = (i + this.slides.length) % this.slides.length;
          this.track.scrollTo({ left: n * this.track.clientWidth, behavior: this.behavior() });
        }

        step(dir) {
          this.go(this.index + dir);
        }

        queueSync() {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = null;
            this.sync();
          });
        }

        sync() {
          const i = this.index;
          this.labels.forEach((b, n) => {
            if (n === i) b.setAttribute('aria-current', 'true');
            else b.removeAttribute('aria-current');
          });
        }

        startAuto() {
          if (this.dataset.autoplay !== 'true') return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.stopAuto();
          const every = (parseInt(this.dataset.interval, 10) || 6) * 1000;
          this.timer = setInterval(() => this.step(1), every);
        }

        stopAuto() {
          clearInterval(this.timer);
        }

        disconnectedCallback() {
          this.stopAuto();
          if (this._raf) cancelAnimationFrame(this._raf);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-change]');
        if (b) { const key = b.closest('.crow').dataset.key; this.change(key, parseInt(b.dataset.change, 10)); }
      });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-input]')) {
          const key = e.target.closest('.crow').dataset.key;
          this.change(key, Math.max(0, parseInt(e.target.value, 10) || 0));
        }
      });
    }
    async change(id, quantity) {
      this.classList.add('cart-items--loading');
      try {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: quantity }) });
        const html = await (await fetch(location.pathname + '?section_id=' + this.section)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
        if (fresh) this.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart' } }));
      } catch (e) { location.reload(); }
      finally { this.classList.remove('cart-items--loading'); }
    }
  }
  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  class FacetForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-auto-submit], input[type=checkbox], input[type=number]')) this.form.submit();
      });
    }
  }
  if (!customElements.get('facet-form')) customElements.define('facet-form', FacetForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.thumbs = Array.from(this.querySelectorAll('.pgallery__thumb'));
      this.dotsWrap = this.querySelector('[data-gallery-dots]');
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');

      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-target]'); if (!t) return;
        this.showMedia(t.getAttribute('data-target'));
      });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1));
      // Scroll position is the single source of truth; no separate index to drift.
      this.track.addEventListener('scroll', () => this.queueSync(), { passive: true });

      this.buildDots();
      this.sync();
    }

    get index() {
      const w = this.track.clientWidth || 1;
      return Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / w)));
    }

    behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    goTo(i) {
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: this.behavior() });
    }

    // Reference wraps: prev on the first shot lands on the last one. Clamping meant the
    // control sat there disabled and the gallery dead-ended at both extremes.
    page(dir) {
      const n = this.slides.length;
      if (!n) return;
      this.goTo(((this.index + dir) % n + n) % n);
    }

    showMedia(id) {
      if (!id) return;
      const i = this.slides.findIndex((s) => s.dataset.mediaId == id);
      if (i >= 0) this.goTo(i);
    }

    buildDots() {
      if (!this.dotsWrap || this.slides.length < 2) return;
      const frag = document.createDocumentFragment();
      this.slides.forEach((_, i) => {
        const li = document.createElement('li');
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pgallery__dot';
        dot.setAttribute('aria-label', String(i + 1));
        dot.addEventListener('click', () => this.goTo(i));
        li.appendChild(dot);
        frag.appendChild(li);
      });
      this.dotsWrap.appendChild(frag);
    }

    queueSync() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => { this._raf = null; this.sync(); });
    }

    sync() {
      const i = this.index;
      this.thumbs.forEach((b, n) => b.classList.toggle('is-active', n === i));
      if (this.dotsWrap) {
        Array.from(this.dotsWrap.querySelectorAll('.pgallery__dot')).forEach((d, n) => {
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }
    }

    disconnectedCallback() { if (this._raf) cancelAnimationFrame(this._raf); }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  // Same element as the content-tabs / product-tabs sections; whichever definition
  // lands first wins and the rest are no-ops.
  if (!customElements.get('atom-tabs')) {
    customElements.define(
      'atom-tabs',
      class AtomTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          if (!this.tabs.length) return;
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
        }
        select(i) {
          this.tabs.forEach((tab, n) => {
            const active = n === i;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            if (this.panels[n]) this.panels[n].hidden = !active;
          });
          this.tabs[i].focus();
        }
        onKey(e, i) {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next);
        }
      }
    );
  }

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      // Resolved on demand: <product-form> sits after this element in the form, so it
      // does not exist yet while this element is upgrading during parse.
      this.addEventListener('change', () => {
        const owner = this.closest('form') && this.closest('form').querySelector('product-form');
        if (owner && owner.onVariantChange) owner.onVariantChange();
      });
    }
    get selectedValues() { return Array.from(this.querySelectorAll('input[type=radio]:checked')).map(i => i.value); }
  }
  if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.variants = JSON.parse(this.form.querySelector('[data-variants]').textContent);
      this.strings = JSON.parse(this.form.querySelector('[data-strings]').textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      this.selects = this.form.querySelector('variant-selects');
      this.status = this.querySelector('[data-atc-status]');
      this.btn = this.querySelector('[data-atc]');
      this.section = this.dataset.section;
      this.querySelectorAll('[data-qty]').forEach(b => b.addEventListener('click', () => this.stepQty(b.dataset.qty)));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      document.querySelectorAll('[data-copy]').forEach(b => b.addEventListener('click', () => this.copyCode(b)));
    }
    copyCode(b) {
      const m = (b.dataset.copy.match(/([A-Z0-9]{4,})/) || [])[1] || b.dataset.copy;
      navigator.clipboard && navigator.clipboard.writeText(m);
      b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
    }
    stepQty(dir) { const q = this.querySelector('.qty__input'); let v = parseInt(q.value, 10) || 1; q.value = dir === 'plus' ? v + 1 : Math.max(1, v - 1); }
    onVariantChange() {
      if (!this.selects) return;
      const vals = this.selects.selectedValues;
      const match = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(vals));
      const priceEl = document.getElementById('price-' + this.section);
      if (!match) { this.setUnavailable(); return; }
      this.idInput.value = match.id;
      if (match.featured_media_id) { const g = document.querySelector('product-gallery'); if (g) g.showMedia(match.featured_media_id); }
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      const text = this.querySelector('[data-atc-text]');
      if (match.available) { this.btn.disabled = false; text.textContent = this.strings.add; }
      else { this.btn.disabled = true; text.textContent = this.strings.soldout; }
    }
    setUnavailable() { this.btn.disabled = true; this.querySelector('[data-atc-text]').textContent = this.strings.unavailable; }
    // Ticked add-ons ride along in the same /cart/add.js call as the main product —
    // one request, one cart refresh, no second endpoint to keep in sync.
    bundleItems() {
      return Array.from(this.form.querySelectorAll('[data-bundle-item]:checked'))
        .filter((cb) => cb.value)
        .map((cb) => ({ id: cb.value, quantity: 1 }));
    }
    async onSubmit(e) {
      e.preventDefault(); this.btn.disabled = true;
      try {
        const items = [{ id: this.idInput.value, quantity: parseInt(this.querySelector('.qty__input').value, 10) || 1 }].concat(this.bundleItems());
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
        this.showStatus(this.strings.added, false);
      } catch (err) { this.showStatus(err.message, true); } finally { this.btn.disabled = false; }
    }
    showStatus(msg, isError) { if (!this.status) return; this.status.textContent = msg; this.status.hidden = false; this.status.classList.toggle('is-error', !!isError); }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atom-tabs')) {
    customElements.define(
      'atom-tabs',
      class AtomTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          if (!this.tabs.length) return;

          this.slider = this.querySelector('[data-tab-slider]');
          this.nav = this.querySelector('[role="tablist"]');

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });

          this.moveSlider();
          if ('ResizeObserver' in window && this.nav) {
            this.ro = new ResizeObserver(() => this.moveSlider());
            this.ro.observe(this.nav);
          }
        }

        moveSlider() {
          if (!this.slider || !this.nav) return;
          const active = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0];
          if (!active) return;
          // offsetLeft is relative to the positioned nav, so no rect maths and no
          // second forced layout after the style write.
          this.slider.style.setProperty('--tab-x', active.offsetLeft - this.nav.scrollLeft + 'px');
          this.slider.style.setProperty('--tab-w', active.offsetWidth);
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }

        select(i) {
          this.tabs.forEach((tab, n) => {
            const active = n === i;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            // Roving tabindex: only the active tab is in the tab order.
            tab.tabIndex = active ? 0 : -1;
            if (this.panels[n]) this.panels[n].hidden = !active;
          });
          this.tabs[i].focus();
          this.moveSlider();
        }

        onKey(e, i) {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.select(next);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atom-count')) {
    customElements.define(
      'atom-count',
      class AtomCount extends HTMLElement {
        connectedCallback() {
          const to = parseFloat(this.dataset.to);
          if (isNaN(to)) return;

          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce || !('IntersectionObserver' in window)) return;

          // NOT this.prefix — Element.prefix is a read-only DOM property and the
          // assignment throws in strict mode, aborting connectedCallback entirely.
          this._to = to;
          this._prefix = this.dataset.prefix || '';
          this._suffix = this.dataset.suffix || '';
          // Match the authored precision so "4.7" doesn't animate to "5".
          const str = String(to);
          this._decimals = str.indexOf('.') > -1 ? str.split('.')[1].length : 0;
          // Park it at zero straight away: the final figure used to be painted first
          // and visibly jumped back down when the section scrolled into view.
          this.textContent = this._prefix + (0).toFixed(this._decimals) + this._suffix;

          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                this.io.disconnect();
                this.run();
              });
            },
            { threshold: 0.4 }
          );
          this.io.observe(this);
        }

        run() {
          const duration = 3000;
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min(1, (now - start) / duration);
            // easeOutCubic — fast start, gentle settle.
            const eased = 1 - Math.pow(1 - p, 3);
            const val = (this._to * eased).toFixed(this._decimals);
            this.textContent = this._prefix + val + this._suffix;
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atom-story-note')) {
    customElements.define(
      'atom-story-note',
      class AtomStoryNote extends HTMLElement {
        connectedCallback() {
          this.btn = this.querySelector('[data-story-toggle]');
          this.panel = this.querySelector('[data-story-panel]');
          if (!this.btn || !this.panel) return;
          this.label = this.btn.querySelector('[data-story-label]');
          this.btn.addEventListener('click', () => this.toggle());
        }

        toggle() {
          const open = this.btn.getAttribute('aria-expanded') === 'true';
          this.btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          this.panel.hidden = open;
          // The icon alone cannot say which way the control goes, so the accessible
          // name flips with it instead of staying stuck on "Show more".
          if (this.label) {
            this.label.textContent = open ? this.btn.dataset.labelMore : this.btn.dataset.labelLess;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-cards"] && !Shopify.designMode) return;
  try {
    
  class AtomTabCards extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.tabcards__tab')];
      this.panels = [...this.querySelectorAll('.tabcards__grid')];
      if (!this.panels.length) return;

      this.tabs.forEach((t) => {
        t.addEventListener('click', () => this.select(t.dataset.tab));
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = this.tabs.indexOf(e.target);
        if (i < 0) return;
        e.preventDefault();
        const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
        next.focus();
        next.click();
      });

      // 沿用服务端标好的激活项（默认不一定是第一个）；没有标签条时只有一个网格
      const preset = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      this.select(preset ? preset.dataset.tab : (this.tabs.length ? this.tabs[0].dataset.tab : '1'));
    }

    select(key) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p) => {
        p.hidden = p.dataset.panel !== key;
      });
    }
  }

  if (!customElements.get('atom-tab-cards')) {
    customElements.define('atom-tab-cards', AtomTabCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["version-history"] && !Shopify.designMode) return;
  try {
    
  class AtomVersionHistory extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.vhist__tab')];
      this.panels = [...this.querySelectorAll('.vhist__list')];
      this.visible = parseInt(this.dataset.visible, 10) || 3;
      if (!this.panels.length) return;

      this.tabs.forEach((t) => {
        t.addEventListener('click', () => this.select(t.dataset.tab));
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = this.tabs.indexOf(e.target);
        if (i < 0) return;
        e.preventDefault();
        const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
        next.focus();
        next.click();
      });

      this.querySelectorAll('[data-more]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', () => this.toggleMore(btn));
      });

      this.select(this.tabs.length ? this.tabs[0].dataset.tab : null);
    }

    select(key) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p) => {
        p.hidden = p.dataset.panel !== key;
      });
    }

    toggleMore(btn) {
      const panel = btn.closest('.vhist__list');
      const open = btn.getAttribute('aria-expanded') === 'true';
      panel.querySelectorAll('.vhist__row').forEach((row) => {
        if (parseInt(row.dataset.index, 10) > this.visible) row.hidden = open;
      });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      const label = btn.querySelector('[data-more-label]');
      if (label && btn.dataset.lessLabel) {
        label.textContent = open ? btn.dataset.moreLabel : btn.dataset.lessLabel;
      }
    }
  }

  if (!customElements.get('atom-version-history')) {
    customElements.define('atom-version-history', AtomVersionHistory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class BgVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { this.load(); this.observer.disconnect(); }
        });
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    load() {
      const src = this.video.getAttribute('data-src');
      if (src && !this.video.src) {
        var host = this;
        var revealed = false;
        var reveal = function () {
          if (!revealed) { revealed = true; host.classList.add('is-playing'); }
        };
        if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
          this.video.requestVideoFrameCallback(reveal);
        } else {
          this.video.addEventListener('playing', function () { setTimeout(reveal, 500); }, { once: true });
        }
        this.video.src = src;
        this.video.play().catch(function () {});
      }
    }
  }
  if (!customElements.get('bg-video')) customElements.define('bg-video', BgVideo);

  } catch(e) { console.error(e); }
})();
})();
